import { Button, Dialog, FormControlLabel, Grid, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, makeStyles } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { traerDatosSuspensionAfiliados } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas";

const useStyles = makeStyles({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
        // width: "100%",
    }
});
export const ModalVerAfiliadosEmpresa = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const componentRef = React.useRef();

    const { datosSuspensionAfiliados } = useSelector((state) => state.comunicacionEmpresas);

    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [page, setPage] = useState(0);
    const [dense, setDense] = useState(true);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        dispatch(traerDatosSuspensionAfiliados(props.cuit));
    }, [dispatch])
    
    return (
        <Dialog
            fullWidth
            maxWidth={"lg"}
            open={props.open}>

            <Grid>
                <Grid>
                    <Typography variant="h6" style={{ textAlign: 'center', margin: '1rem' }}>Afiliados Asociados a Empresa</Typography>
                </Grid>
                <Grid container justify="center" className={classes.root} spacing={1}>
                    <Paper>
                        <TableContainer component={Paper} >
                            <Table size={dense ? "small" : "medium"} ref={componentRef} >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Cuil</TableCell>
                                        <TableCell>Carnet</TableCell>
                                        <TableCell>Nombre y Apellido</TableCell>
                                        <TableCell>Judicializado</TableCell>
                                        <TableCell>Incap</TableCell>
                                        <TableCell>Telefono</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Sin Ficha</TableCell>
                                        <TableCell>Familiar Disca</TableCell>
                                        <TableCell>Rama Por Reunion</TableCell>
                                        <TableCell>Pluriempleo</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {datosSuspensionAfiliados?.length > 0 ? (
                                        datosSuspensionAfiliados.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((item) => (
                                                <TableRow>
                                                    <TableCell>{item.cuil}</TableCell>
                                                    <TableCell>{item.carnet}</TableCell>
                                                    <TableCell>{item.apellido_nombre}</TableCell>
                                                    <TableCell>{item.judicializado === true ? "SI" : "NO"}</TableCell>
                                                    <TableCell>{item.incapacitado === true ? "SI" : "NO"}</TableCell>
                                                    <TableCell>{item.telefono}</TableCell>
                                                    <TableCell>{item.mail}</TableCell>
                                                    <TableCell>{item.sinFichaAfiliacion === true ? "SI" : "NO"}</TableCell>
                                                    <TableCell>{item.cantDisca > 0 ? "SI" : "NO"}</TableCell>
                                                    <TableCell>{item.ramaPorReunion ? "SI" : "NO"}</TableCell>
                                                    <TableCell>{item.pluriempleo}</TableCell>
                                                </TableRow>
                                            ))
                                    ) : (<TableRow style={{ height: 50 }}>
                                        <TableCell
                                            colSpan={13}
                                            style={{ textAlign: "-webkit-center" }}
                                        >
                                            {" "}
                                            Sin Registros
                                        </TableCell>
                                    </TableRow>)}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Paper>
                    {datosSuspensionAfiliados?.length > 0 && (
                        <Grid item xs={12}>
                            <TablePagination
                                style={{ backgroundColor: "white" }}
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={datosSuspensionAfiliados.length}
                                rowsPerPage={rowsPerPage}
                                labelRowsPerPage="Registros por página"
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={dense}
                                        onChange={(e) => setDense(e.target.checked)}
                                    />
                                }
                                label="Tamaño compacto"
                            />
                        </Grid>
                    )}

                    <Grid container style={{ padding: 25 }} >
                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={props.onClose}
                            >
                                CERRAR
                            </Button>
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        </Dialog >
    )
};